export const ONE_DAY_MS = 24 * 60 * 60 * 1000
